import { Sprite, Container, Graphics } from 'pixi.js'

export default {
  render: h => h(),
  beforeDestroy() {},
  data: () => ({}),
  created() {
    this.$tl = this.$parent.$tl
    this.$container = this.$parent.$container
    this.$resources = this.$parent.$resources
    this.$stage = this.$parent.$sprite
    this.$canvas_width = this.$parent.$parent.canvas_width
    this.$canvas_height = this.$parent.$parent.canvas_height
  },
  mounted() {},
  methods: {
    createBg(color) {
      const graphic = new Graphics()
      graphic.beginFill(color ? color : 0xFFFFFF)
      graphic.drawRect(0, 0, 768, 1080)
      graphic.endFill()
      graphic.position.x = -768 / 2
      graphic.position.y = -1080 / 2
      return graphic
    },
    setCenterContainer(container) {
      container.x = this.$canvas_width/2
      container.y = this.$canvas_height/2
    },
    setCropPositions(ref, crops, sprites) {
      const data = crops[ref]
      const sprite = sprites[ref]
      const x = data.x + (Math.ceil(data.width/2))
      const y = data.y + (Math.ceil(data.height/2))
      sprite.x = x/2 - this.$canvas_width/2
      sprite.y = y/2 - this.$canvas_height/2
      sprite.anchor.set(.5)
    },
    setPosition(sprite, data) {
      const x = data.x + (Math.ceil(data.width/2))
      const y = data.y + (Math.ceil(data.height/2))
      sprite.x = x/2 - this.$canvas_width/2
      sprite.y = y/2 - this.$canvas_height/2
      sprite.anchor.set(.5)
    },
    setAnchor(sprite, data) {
      const x = data.anchor.x
      const y = data.anchor.y
      sprite.anchor.set(x, y) 
      if(data.position) {
        if(x === 0) sprite.x -= data.position.width/4
        else if(x === 1) sprite.x += data.position.width/4
        if(y === 0) sprite.y -= data.position.height/4
        else if(y === 1) sprite.y += data.position.height/4
      }  
    },
    setTint(sprite, tint) {
      sprite.tint = tint
    },
    setRotation(sprite, angle) { sprite.rotation = (Math.PI*angle)/180 },
    setX(sprite, x) { sprite.x = sprite.x + x },
    setY(sprite, y) { sprite.y = sprite.y + y },
    applySettings(sprite, data) {
      if(data.position) 
        this.setPosition(sprite, data.position)
      if(data.scale) 
        sprite.scale.set(data.scale)
      if(data.anchor)
        this.setAnchor(sprite, data)
      if(data.rotation)
        this.setRotation(sprite, data.rotation)
      if(data.x)
        this.setX(sprite, data.x)
      if(data.y)
        this.setY(sprite, data.y)
      if(data.tint)
        this.setTint(sprite, data.tint)
    }
  }
}
